var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17C17 18.6569 15.6569 20 14 20H9C7.34315 20 6 18.6569 6 17V7H5V6H18V7H17V17ZM9 9H10V16H9V9ZM11 9H12V16H11V9ZM13 9H14V16H13V9ZM7 17C7 18.1046 7.89543 19 9 19H14C15.1046 19 16 18.1046 16 17V7H7V17ZM13 6V5H10V6H9V5C9 4.44772 9.44772 4 10 4H13C13.5523 4 14 4.44772 14 5V6H13Z",
    fill: "#000624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dc6ae39383ac4c4bc24c07db100456b2.svg";
export { ForwardRef as ReactComponent };